import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Box, IconButton, Tooltip } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"
import { DataGrid, GridActionsCellItem, GridCellModes, GridRowModes, GridToolbarContainer } from "@mui/x-data-grid"
import InputModal from "../../modals/InputModal"
import ConfirmModal from "../../modals/ConfirmModal"
import { parseMoneyInput } from "../../../Utils"

function AddToolbar(props) {
    const { onClick, disabled } = props;

    return (
        <GridToolbarContainer>
            <Button color="primary" startIcon={<AddIcon />} onClick={onClick} disabled={disabled}>
                Add Attribute
            </Button>
        </GridToolbarContainer>
    );
}

export default function ServiceOrderItemTypeModal({
    serviceorderitemtype,
    open,
    closeModal,
    creatingNewServiceOrderItemType,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const [myServiceOrderItemType, setMyServiceOrderItemType] = React.useState(serviceorderitemtype)
    const [saving, setSaving] = React.useState(false)
    const [edited, setEdited] = React.useState(false)
    const [extraAttrsCellModesModel, setExtraAttrsCellModesModel] = React.useState({});
    const [newAttributeModal, setNewAttributeModal] = React.useState({
        open: false,
        label: 'New Customer Item Attribute',
        title: 'Add Attribute',
    });
    const [confirmModal, setConfirmModal] = React.useState({
        open: false,
        text: '',
        callback: null
    })
    React.useEffect(() => {
        setMyServiceOrderItemType(serviceorderitemtype)
    }, [serviceorderitemtype])
    const extra_attrs_columns = [
        {
            field: 'id',
            headerName: 'Extra Attributes',
            flex: 1,
            editable: true,
            sortable: false,
            filterable: false
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Delete',
            width: 75,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<DeleteIcon color="error" />}
                        label="Delete"
                        onClick={() => handleDeleteExtraAttrClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ]

    const handleChange = (prop) => (event) => {
        if (prop === "deposit") {
            setMyServiceOrderItemType({ ...myServiceOrderItemType, [prop]: parseMoneyInput(myServiceOrderItemType[prop], event.target.value, { allow_empty: true }) || 0 })
        } else {
            setMyServiceOrderItemType({ ...myServiceOrderItemType, [prop]: event.target.value })
        }
    }
    const addAttr = () => {
        setNewAttributeModal({
            ...newAttributeModal,
            open: true,
            callback: (results, value) => {
                if (results && !(myServiceOrderItemType.extra_attrs ?? []).includes(value)) {
                    if (creatingNewServiceOrderItemType) {
                        setMyServiceOrderItemType({ ...myServiceOrderItemType, extra_attrs: myServiceOrderItemType.extra_attrs.concat([value]) });
                    } else {
                        setSaving(true)
                        send_authorized_request(() =>
                            AXIOS_API_INSTANCE.post(
                                `serviceorderitemtypes/${myServiceOrderItemType.id}/add_attribute`,
                                { attribute: value }
                            ).then((serviceOrderItemType) => {
                                enqueueSnackbar('Successfully updated service order item type', { variant: 'success' })
                                setSaving(false)
                                setMyServiceOrderItemType({ ...myServiceOrderItemType, extra_attrs: serviceOrderItemType.data.data.extra_attrs })
                                setEdited(true)
                            }).catch((error) => {
                                setSaving(false)
                                enqueueSnackbar(`Failed to update service order item type <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                            })
                        )
                    }
                }
                setNewAttributeModal({ ...newAttributeModal, open: false })
            },
        })
    }

    const handleDeleteExtraAttrClick = (attr) => {
        setConfirmModal({
            open: true,
            text: `Are you sure you want to delete the attribute ${attr}?`,
            callback: (confirmation) => {
                if (confirmation) {
                    setSaving(true)
                    send_authorized_request(() =>
                        AXIOS_API_INSTANCE.post(
                            `serviceorderitemtypes/${myServiceOrderItemType.id}/delete_attribute`,
                            { attribute: attr }
                        ).then((serviceOrderItemType) => {
                            enqueueSnackbar(`Successfully deleted ${attr} attribute`, { variant: 'success' })
                            setSaving(false)
                            setMyServiceOrderItemType({ ...myServiceOrderItemType, extra_attrs: serviceOrderItemType.data.data.extra_attrs })
                            setEdited(true)
                        }).catch((error) => {
                            setSaving(false)
                            enqueueSnackbar(`Deleting ${attr} attribute failed <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                        })
                    )
                }
                setConfirmModal({ ...confirmModal, open: false })
            }
        })
    }

    const save = (event) => {
        setSaving(true)
        delete myServiceOrderItemType.date_created
        delete myServiceOrderItemType.date_updated
        if (creatingNewServiceOrderItemType) {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.put(`serviceorderitemtypes`, myServiceOrderItemType).then(() => {
                    setSaving(false)
                    enqueueSnackbar('Successfully created service order item type', { variant: 'success' })
                    closeModal(true)
                }).catch((error) => {
                    setSaving(false)
                    enqueueSnackbar(`Failed to create service order item type <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        } else {
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(
                    `serviceorderitemtypes/${myServiceOrderItemType.id}`,
                    myServiceOrderItemType
                ).then(() => {
                    enqueueSnackbar('Successfully updated service order item type', { variant: 'success' })
                    setSaving(false)
                    closeModal(true)
                }).catch((error) => {
                    setSaving(false)
                    enqueueSnackbar(`Failed to update service order item type <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        }
    }
    const deleteServiceOrderItemType = () => {
        send_authorized_request(() =>
            AXIOS_API_INSTANCE.delete(`serviceorderitemtypes/${myServiceOrderItemType.id}`).then(() => {
                enqueueSnackbar('Successfully deleted service order item type', { variant: 'success' })
                closeModal(true)
            })
        )
    }

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(edited)}
                maxWidth={'lg'}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <LoadingBackdropIndeterminate
                    open={saving}
                    text={"Saving Service Item Type"}
                />
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>{creatingNewServiceOrderItemType ? "Creating Service Item Type" : "Modifying Service Item Type"}</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(edited)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Grid container direction="column" spacing={1}>
                            <Grid size="grow">
                                <TextField
                                    margin="dense"
                                    id="name"
                                    label="Name"
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    value={myServiceOrderItemType?.name ?? ''}
                                    onChange={handleChange("name")}
                                />
                            </Grid>
                            <Grid size="grow">
                                <TextField
                                    margin="dense"
                                    id="description"
                                    label="Description"
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    value={myServiceOrderItemType?.description ?? ''}
                                    onChange={handleChange("description")}
                                />
                            </Grid>
                            <Grid size="grow">
                                <TextField
                                    margin="dense"
                                    id="deposit"
                                    label="Deposit"
                                    type="number"
                                    fullWidth
                                    variant="filled"
                                    value={(myServiceOrderItemType?.deposit ?? '').toString()}
                                    onChange={handleChange("deposit")}
                                />
                            </Grid>
                            <Grid size="grow">
                                <DataGrid
                                    rows={(myServiceOrderItemType?.extra_attrs ?? []).map((x) => { return { id: x } })}
                                    columns={extra_attrs_columns}
                                    // cellModesModel={extraAttrsCellModesModel}
                                    editMode="row"
                                    rowModesModel={extraAttrsCellModesModel}
                                    // onRowEditStop={(params, event) => {
                                    //     if (params.reason === GridRowEditStopReasons.rowFocusOut) {
                                    //         event.defaultMuiPrevented = true;
                                    //     }
                                    // }}
                                    processRowUpdate={(newRow, oldRow) => {
                                        if ((myServiceOrderItemType?.extra_attrs ?? []).find((a) => a === newRow.id) === newRow.id) {
                                            return oldRow;
                                        }
                                        setMyServiceOrderItemType({ ...myServiceOrderItemType, extra_attrs: myServiceOrderItemType.extra_attrs.map((a) => (a === oldRow.id ? newRow.id : a)) })
                                        return newRow;
                                    }}
                                    onRowModesModelChange={React.useCallback((newModel) => setExtraAttrsCellModesModel(newModel), [])}
                                    onCellClick={React.useCallback((params, event) => {
                                        if (!params.isEditable) {
                                            return;
                                        }

                                        // Ignore portal
                                        if (event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) {
                                            return;
                                        }

                                        setExtraAttrsCellModesModel((prevModel) => {
                                            return {
                                                // Revert the mode of the other cells from other rows
                                                ...Object.keys(prevModel).reduce(
                                                    (acc, id) => ({
                                                        ...acc,
                                                        [id]: {
                                                            mode: GridRowModes.View
                                                        },
                                                    }),
                                                    {},
                                                ),
                                                [params.id]: { mode: GridCellModes.Edit, fieldToFocus: 'id' },
                                            };
                                        });
                                    }, [])}
                                    slots={{
                                        toolbar: AddToolbar
                                    }}
                                    slotProps={{
                                        toolbar: { onClick: addAttr },
                                    }}
                                    disableColumnMenu
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                            {!creatingNewServiceOrderItemType &&
                                <Tooltip title={myServiceOrderItemType?.deletable_reason}>
                                    <span> {/* span required for tooltip events */}
                                        <Button disabled={!myServiceOrderItemType?.deletable} variant='outlined' color='error' onClick={deleteServiceOrderItemType} sx={{ mr: 1 }}>
                                            <DeleteIcon /> <Box sx={{ pl: 1 }}><span>Delete</span></Box>
                                        </Button>
                                    </span>
                                </Tooltip>
                            }
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save} disabled={Object.keys(extraAttrsCellModesModel).length !== 0}>
                                {creatingNewServiceOrderItemType ? "Create" : "Save"}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
            <InputModal
                {...newAttributeModal}
            />
            <ConfirmModal
                {...confirmModal}
            />
        </div>)
    );
}
